export default {
    baseStyle: {
        countryDropDownArrow: {
            width: 0,
            height: 0,
            borderLeft: '3px solid transparent',
            borderRight: '3px solid transparent',
            borderTopWidth: '4px',
            borderTopStyle: 'solid',
            borderTopColor: 'gray.700',
            padding: 0,
            marginTop: '1px'
        },
        menuOptions: {
            display: 'inline',
            gap: 2,
            whiteSpace: {sm: 'nowrap'},
            textOverflow: {sm: 'ellipsis'}
        },
        menuDivider: {
            borderTopWidth: '1px',
            borderTopStyle: 'solid',
            borderTopColor: 'gray.300',
            mt: '10px',
            w: '100%',
            mx: 'auto',
            position: 'absolute',
            bottom: '0',
            left: '0'
        },
        menuOptionsIcon: {
            width: '20px',
            height: '20px',
            borderRadius: '0.125rem',
            display: 'inline',
            paddingTop: '6px',
            marginRight: '4px'
        },
        menuOptionsValueText: {
            display: 'inline',
            whiteSpace: {sm: 'nowrap'},
            textOverflow: {sm: 'ellipsis'},
            light: {
                color: 'gray.525'
            }
        },
        icon: {
            width: '20px',
            height: '20px',
            borderRadius: '0.125rem'
        },
        dropDown: {
            alignItems: 'center',
            gap: '0.5rem',
            padding: 0
        },
        selectContainer: {
            flexDirection: 'column',
            position: 'relative',
            overflowX: 'hidden',
            box: {
                height: '38px',
                zIndex: 100,
                position: 'absolute'
            }
        },
        countrySelect: {
            container: (base) => ({
                ...base,
                height: '100%',
                margin: '1px'
            }),
            menu: (provided) => ({
                ...provided,
                width: (() => {
                    return window.innerWidth > 520 ? 'fit-content' : '250px'
                })(),
                position: 'relative',
                zIndex: '99'
            }),
            control: (provided) => ({
                ...provided,
                border: 'none',
                backgroundColor: 'transparent',
                borderRadius: 'none',
                boxShadow: 'none',
                height: '100%',
                flexWrap: 'nowrap',
                paddingRight: '0px',
                '&:hover': {background: '#F2F2F2'},
                '&:focus-visible': {outline: 'none'}
            }),
            option: (provided, state) => ({
                ...provided,
                width: '100%',
                backgroundColor: state.isSelected ? 'white' : state.isFocused ? '#F2F2F2' : 'white',
                color: 'black',
                position: 'relative',
                '&:hover': {
                    backgroundColor: '#F2F2F2'
                }
            }),
            placeholder: (provided) => ({
                ...provided,
                color: 'gray.525'
            }),
            singleValue: (provided) => ({
                ...provided,
                display: 'flex',
                alignItems: 'center',
                zIndex: 999,
                height: '100%',
                margin: 0,
                padding: 0
            }),
            valueContainer: (provided) => ({
                ...provided,
                paddingLeft: '6px',
                paddingRight: '0'
            }),
            menuPortal: (base) => ({
                ...base,
                zIndex: 9999
            }),
            indicatorSeparator: () => ({
                display: 'none'
            }),
            indicatorContainer: (provided) => ({
                ...provided,
                paddingLeft: '4px'
            })
        }
    }
}
